import { X, Send, Loader2 } from "lucide-react";

export default function HandoffForm({ form, onClose }) {
    const {
        name, setName,
        email, setEmail,
        phone, setPhone,
        message, setMessage,
        submitting, error, submit,
    } = form;

    return (
        <form onSubmit={submit} className="px-5 py-5 space-y-3" data-testid="handoff-form">
            <div className="flex items-start justify-between mb-1">
                <div>
                    <p className="text-[10.5px] uppercase tracking-[0.16em] text-[#C8A24A] font-semibold">
                        Talk to a real person
                    </p>
                    <h3 className="font-[Outfit] text-[17px] font-semibold text-[#1A2230] mt-1">
                        Message Dorothy &amp; Valerie
                    </h3>
                </div>
                <button
                    type="button"
                    onClick={onClose}
                    className="rounded-full p-1.5 hover:bg-[#F0EBE1] text-[#6F6B63]"
                    aria-label="Close"
                    data-testid="handoff-close"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>

            <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name *"
                className="w-full rounded-xl bg-[#F7F5F0] border border-[#E5DFD3] px-3.5 py-2.5 text-[13.5px] focus:outline-none focus:border-[#0E2A47]"
                data-testid="handoff-name"
            />
            <div className="grid grid-cols-2 gap-2">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    className="rounded-xl bg-[#F7F5F0] border border-[#E5DFD3] px-3.5 py-2.5 text-[13.5px] focus:outline-none focus:border-[#0E2A47]"
                    data-testid="handoff-email"
                />
                <input
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone"
                    className="rounded-xl bg-[#F7F5F0] border border-[#E5DFD3] px-3.5 py-2.5 text-[13.5px] focus:outline-none focus:border-[#0E2A47]"
                    data-testid="handoff-phone"
                />
            </div>
            <p className="text-[10.5px] text-[#8F8B83] -mt-1">
                Share either an email or a phone number — whichever is easiest.
            </p>
            <textarea
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="What would you like the team to know? *"
                className="w-full rounded-xl bg-[#F7F5F0] border border-[#E5DFD3] px-3.5 py-2.5 text-[13.5px] focus:outline-none focus:border-[#0E2A47] resize-none"
                data-testid="handoff-message"
            />
            {error && (
                <p className="text-[12px] text-[#a04545]" data-testid="handoff-error">
                    {error}
                </p>
            )}
            <button
                type="submit"
                disabled={submitting}
                className="w-full rounded-full bg-[#0E2A47] text-white py-2.5 text-[13.5px] font-medium flex items-center justify-center gap-2 hover:bg-[#08182B] disabled:opacity-50 transition-colors"
                data-testid="handoff-submit"
            >
                {submitting ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                    <Send className="h-3.5 w-3.5" />
                )}
                Send to the team
            </button>
            <p className="text-[10.5px] text-[#8F8B83] text-center pt-1">
                Goes directly to Dorothy &amp; Valerie · No clinical info, please
            </p>
        </form>
    );
}
